import MapElement from './MapElement';
import FeatureDrawer from '../helpers/FeatureDrawer';
import VectorImageLayer from 'ol/layer/VectorImage';

import * as olExtent from 'ol/extent';
import 'ol/ol.css';
import VectorImage from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import LineString from 'ol/geom/LineString';

import Circle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Point from 'ol/geom/Point';
import VectorLayer from 'ol/layer/Vector';

export default class MapMotionplan extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent)
        this.parentId = parent.id;
        this.motionplan = null;
        this.source = null

        this.noKey = true;

        this.styleCache = {}
    }

    drawLayer(motionplan, projection) {
        this.projection = projection;
        this.motionplan = motionplan;
        this.draw();

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }
    }

    initializeSelect() {
        super.initializeSelect();
        this.selectInteraction.style_ = (ft, res) => { return MapMotionplan.customLineStyle(ft, res, this.mapModel.dark, true) };
    }

    draw() {
        this.styleCache = {};

        var style = (ft, res) => {
            const geometry = ft.getGeometry().getType()
            if (geometry == "Point" && res > 1) return;

            const segmentId = ft.get('motionplanSegmentIndex')
            var value = geometry + segmentId;

            // Check if style is already cached
            if (!this.styleCache[value]) {
                // Create and cache the style if it doesn't exist
                this.styleCache[value] = MapMotionplan.customLineStyle(ft, res, this.mapModel.dark, false)
            }

            // Return the cached style
            return this.styleCache[value];
        };

        if (!this.layer) {
            this.source = new VectorSource();
            this.layer = new VectorLayer({
                parentId: this.parentId,
                source: this.source,
                style: style,
            });
            this.parent.layer.getLayers().push(this.layer);
        }
        this.source.clear();

        var featureDrawer = new FeatureDrawer(this.projection, this.mapModel.projection);

        var lastSegment = null
        this.motionplan.data.forEach((segment, index) => {
            var feature = null;
            //segment
            if (lastSegment) {
                if (segment.Curvature != 0 ) { // TODO curvature so it works with circles on 0.0
                    var curvature = segment.Curvature
                    const clockwise = curvature < 0;
                    var center = { x: segment.CentreX, y: segment.CentreY };
                    var arc;
                    var startAngle = segment.SegmStartAngle;
                    var endAngle = segment.SegmEndAngle;
                    var r = Math.sqrt(Math.pow(center.x - segment.X, 2) + Math.pow(center.y - segment.Y, 2));

                    var points = [];

                    if (clockwise) {
                        let difference = startAngle - endAngle;
                        if (difference < 0) {
                            difference += 2 * Math.PI;
                        }

                        let rotatedAngle, x, y;
                        endAngle = endAngle + (0.5 * Math.PI);

                        for (let i = 0; i < (difference * (180 / Math.PI)); ++i) {
                            rotatedAngle = endAngle + (i * (Math.PI / 180));
                            x = center.x + (r * Math.cos(rotatedAngle));
                            y = center.y + (r * Math.sin(rotatedAngle));
                            let vertex = { x: x, y: y }
                            if (this.projection != null) {
                                vertex = featureDrawer.transformCoordinates(vertex);
                            }
                            points.push([vertex.x, vertex.y]);
                        }
                        rotatedAngle = startAngle + (0.5 * Math.PI);
                        x = center.x + (r * Math.cos(rotatedAngle));
                        y = center.y + (r * Math.sin(rotatedAngle));
                        let vertex = { x: x, y: y }
                        if (this.projection != null) {
                            vertex = featureDrawer.transformCoordinates(vertex);
                        }
                        points.push([vertex.x, vertex.y]);
                    } else {
                        let difference = endAngle - startAngle;
                        if (difference < 0) {
                            difference += 2 * Math.PI;
                        }
                        let rotatedAngle, x, y;
                        startAngle = startAngle - (0.5 * Math.PI);
                        for (let i = 0; i < (difference * (180 / Math.PI)); ++i) {
                            rotatedAngle = startAngle + (i * (Math.PI / 180));
                            x = center.x + (r * Math.cos(rotatedAngle));
                            y = center.y + (r * Math.sin(rotatedAngle));
                            let vertex = { x: x, y: y }
                            if (this.projection != null) {
                                vertex = featureDrawer.transformCoordinates(vertex);
                            }
                            points.push([vertex.x, vertex.y]);
                        }
                        rotatedAngle = endAngle - (0.5 * Math.PI);
                        x = center.x + (r * Math.cos(rotatedAngle));
                        y = center.y + (r * Math.sin(rotatedAngle));
                        let vertex = { x: x, y: y }
                        if (this.projection != null) {
                            vertex = featureDrawer.transformCoordinates(vertex);
                        }
                        points.push([vertex.x, vertex.y]);
                    }
                    arc = new LineString(points);
                    feature = new Feature(arc);
                } else {
                    feature = featureDrawer.drawFeature(
                        {
                            type: "LINE",
                            start: { x: lastSegment.X, y: lastSegment.Y },
                            end: { x: segment.X, y: segment.Y }
                        }
                    );
                }

                feature.set("motionplanSegmentIndex", index);
                feature.set("motionplanElementId", this.id);
                feature.set("arguments", segment.functionArray);
                this.source.addFeature(feature);
            }

            let featurePoint = featureDrawer.drawFeature({ type: "POINT", x: segment.X, y: segment.Y })
            featurePoint.set("motionplanSegmentIndex", index);
            featurePoint.set("motionplanElementId", this.id);

            featurePoint.set("arguments", segment.functionArray);
            this.source.addFeature(featurePoint);

            // // point
            // segment.functionArray.forEach(segmentFunction => {
            //     if (segmentFunction.IdentifierFunction == 1) {
            //         let featurePoint = featureDrawer.drawFeature({ type: "POINT", x: segment.X, y: segment.Y })
            //         featurePoint.set("motionplanSegmentIndex", index);
            //         featurePoint.set("motionplanElementId", this.id);

            //         featurePoint.set("arguments", segment.functionArray);
            //         this.source.addFeature(featurePoint);
            //     }
            // });

            lastSegment = segment;
        });
    }

    getLayers() {
        if (!this.layer) {
            return null;
        }
        const layerObject = {
            id: this.parent.id + "-" + this.id,
            name: this.motionplan.name ? this.motionplan.name : this.id,
            editButton: this.mapElementSettings.editButton,
            actions: this.mapElementSettings.actions,
            checkBoxValue: false,
            visible: this.visible,
            disabled: this.disabled,
            show: this.show.bind(this),
            hide: this.hide.bind(this),
            children: []
        };
        return layerObject
    }


    static customLineStyle(ft, res, dark, selecting) {
        if (ft.getGeometry().getType() == "Point") {
            return MapMotionplan.getPointStyle(ft, res, dark, selecting)
        } else { // lines
            return MapMotionplan.getLineStyle(ft, res, dark, selecting)
        }
    }

    static getLineStyle(ft, res, dark, selecting) {
        var white = [255, 255, 255, 1];
        var blue = [0, 153, 255, 1];
        var width = 2;
        var lineFunctionColors = { 0: "#969696", 51: "#000000", 153: "#00008C", 152: "#0000FF", 154: "#00FFFF", 157: "#FF00FF", 156: "#800080" }
        //var lineFunctionInvertedColors = { 0: "#696969", 51: "#ffffff", 153: "#ffff73", 152: "#ffff00", 154: "#ff0000", 157: "#00ff00", 156: "#7fff7f" } // colors for darkmode
        var lineFunctionInvertedColors = { 0: "#666666", 51: "#ffffff", 153: "#8080ff", 152: "#0000FF", 154: "#00FFFF", 157: "#FF00FF", 156: "#ff80ff" }

        var selectLineStyle = (thin = false) => [
            new Style({
                stroke: new Stroke({
                    color: white,
                    width: thin ? width + 1 : width + 2,
                })
            }),
            new Style({
                stroke: new Stroke({
                    color: blue,
                    width: thin ? width - 1 : width,
                })
            })
        ]

        var lineStyle = (colorKey, dark, thin = false) => {
            return [
                new Style({
                    stroke: new Stroke({
                        color: dark ? lineFunctionInvertedColors[colorKey] : lineFunctionColors[colorKey],
                        width: thin ? width - 1 : width,
                    })
                })]
        }
        // style for spray on 

        if (ft.get("arguments").some(s => {
            return (s.IdentifierFunction == 51 && s.Arguments[0] == 1)
        })) {
            if (selecting) {
                return selectLineStyle()
            } else {
                return lineStyle(51, dark)
            }
        } else if (ft.get("arguments").some(s => {
            return (s.IdentifierFunction == 51 && s.Arguments[0] == 0)
        })) {
            if (selecting) {
                return selectLineStyle(true)
            } else {
                return lineStyle(0, dark, true)
            }
        }
        else {
            var style = null
            ft.get('arguments').forEach(key => {
                if (style) {
                    return;
                }
                Object.keys(lineFunctionColors).forEach(colorKey => {
                    if (key.IdentifierFunction == colorKey) {
                        if (selecting) {
                            style = selectLineStyle()
                            return;
                        } else {
                            style = lineStyle(colorKey, dark)
                            return;
                        }
                    }
                });
            });
            if (!style) {
                if (selecting) {
                    style = selectLineStyle(true)
                } else {
                    style = lineStyle(0, dark)
                }
            }
            return style
        }
    }

    static getPointStyle(ft, res, dark, selecting) {
        var blue = [0, 153, 255, 1];
        var pointFunctionColors = { 0: "#ffffff", 101: "#00008c" }
        var pointFunctionInvertedColors = { 0: "#000000", 101: "#ffff73" }
        //var pointFunctionInvertedColors = { 0: "#000000", 101: "#8080ff" }

        var selectPointStyle = (colorKey, dark) => [
            new Style({
                image: new Circle({
                    fill: new Fill({
                        color: dark ? pointFunctionInvertedColors[colorKey] : pointFunctionColors[colorKey]
                    }),
                    radius: 4,
                    stroke: new Stroke({
                        color: blue,
                        width: 1
                    })
                })
            })
        ]

        var pointStyle = (colorKey, dark) => {
            return [
                new Style({
                    image: new Circle({
                        fill: new Fill({
                            color: dark ? pointFunctionInvertedColors[colorKey] : pointFunctionColors[colorKey]
                        }),
                        radius: 4,
                        stroke: new Stroke({
                            color: dark ? 'white' : 'black',
                            width: 1
                        })
                    })
                })]
        }

        if (ft.get("arguments").some(s => {
            return (s.IdentifierFunction == 1 || s.IdentifierFunction == 101)
        })) {
            if (selecting) {
                return selectPointStyle(101, dark)
            } else {
                return pointStyle(101, dark) // darkblue
            }
        } else {
            if (selecting) {
                return selectPointStyle(0, dark)
            } else {
                return null //pointStyle(0, dark) // white
            }
        }
    }

    selectSegment(segmentIndex) {
        var selectedFeatures = this.layer.getSource().getFeatures().filter(feature => {
            return feature.get("motionplanSegmentIndex") == segmentIndex
        });

        this.parent.selectInteraction.getFeatures().clear();
        if (selectedFeatures) {
            selectedFeatures.forEach(feature => {
                this.parent.selectInteraction.getFeatures().push(feature);
            })

            const totalExtend = selectedFeatures.reduce((te, feature) => {
                if (te) {
                    return olExtent.extend(te, feature.getGeometry().getExtent())
                } else {
                    return feature.getGeometry().getExtent()
                }
            }, null)

            var center = olExtent.getCenter(totalExtend);

            var size = this.mapModel.map.getSize();

            var mostLeftCoords = this.mapModel.map.getCoordinateFromPixel([0, 0]);
            var mostRightCoords = this.mapModel.map.getCoordinateFromPixel([size[0], 0]);

            var offset = (mostRightCoords[0] - mostLeftCoords[0]) / 6

            var view = this.mapModel.map.getView();

            view.animate({
                center: [center[0] - offset, center[1]],
                duration: 100 // duration in milliseconds
            });
        }
    }

    selectMotionplan() {
        var selectedFeatures = this.layer.getSource()?.getFeatures();

        // check if this still works when implementing multiple mps on tmi
        if (this.parent.selectInteraction) {
            this.parent.selectInteraction.getFeatures().clear();
        }
        if (this.selectInteraction) {
            this.selectInteraction.getFeatures().clear();
        }

        if (selectedFeatures) {
            selectedFeatures.forEach(feature => {
                if (this.parent.selectInteraction) {
                    this.parent.selectInteraction.getFeatures().push(feature);
                }

                if (this.selectInteraction) {
                    this.selectInteraction.getFeatures().push(feature);
                }
            })
        }
    }

    combineFeatures() {
        const style = (feature) => {
            const geomType = feature.getGeometry().getType();
            if (geomType === 'LineString') {
                const styles = [new Style({
                    stroke: new Stroke({
                        color: '#808080',  // Gray color for the line
                        width: 1           // Width of the line
                    })
                })];
                const coordinates = feature.getGeometry().getCoordinates();

                if (coordinates.length > 0) {
                    // Start point
                    styles.push(new Style({
                        geometry: new Point(coordinates[0]),
                        image: new Circle({
                            fill: new Fill({
                                color: '#ff0000'  // Red color for the endpoint
                            }),
                            radius: 5,           // Size of the endpoint dot
                            stroke: new Stroke({
                                color: '#ff0000', // Red border for the endpoint dot
                                width: 2
                            })
                        })
                    }));

                    // End point
                    styles.push(new Style({
                        geometry: new Point(coordinates[coordinates.length - 1]),
                        image: new Circle({
                            fill: new Fill({
                                color: '#ff0000'  // Red color for the endpoint
                            }),
                            radius: 4,           // Size of the endpoint dot
                            stroke: new Stroke({
                                color: '#ff0000', // Red border for the endpoint dot
                                width: 2
                            })
                        })
                    }));
                }

                return styles;
            } else if (geomType === 'Point') {
                return new Style({
                    image: new Circle({
                        fill: new Fill({
                            color: '#ff0000'  // Red color for the point
                        }),
                        radius: 4,           // Size of the point dot
                        stroke: new Stroke({
                            color: '#ff0000', // Red border for the point dot
                            width: 2
                        })
                    })
                });
            }

            return null;
        };


        this.layer.setStyle(style)

        this.source.clear();

        var featureDrawer = new FeatureDrawer(this.projection, this.mapModel.projection);

        var lastSegment = null;
        var allPoints = [];

        this.motionplan.data.forEach((segment) => {
            if (lastSegment) {
                if (segment.Curvature != 0) {
                    var curvature = segment.Curvature;
                    const clockwise = curvature < 0;
                    var center = { x: segment.CentreX, y: segment.CentreY };
                    var startAngle = segment.SegmStartAngle;
                    var endAngle = segment.SegmEndAngle;
                    var r = Math.sqrt(Math.pow(center.x - segment.X, 2) + Math.pow(center.y - segment.Y, 2));

                    if (clockwise) {
                        let difference = startAngle - endAngle;
                        if (difference < 0) {
                            difference += 2 * Math.PI;
                        }

                        let rotatedAngle, x, y;
                        endAngle = endAngle + (0.5 * Math.PI);

                        for (let i = 0; i < (difference * (180 / Math.PI)); ++i) {
                            rotatedAngle = endAngle + (i * (Math.PI / 180));
                            x = center.x + (r * Math.cos(rotatedAngle));
                            y = center.y + (r * Math.sin(rotatedAngle));
                            let vertex = { x: x, y: y }
                            if (this.projection != null) {
                                vertex = featureDrawer.transformCoordinates(vertex);
                            }
                            allPoints.push([vertex.x, vertex.y]);
                        }
                        rotatedAngle = startAngle + (0.5 * Math.PI);
                        x = center.x + (r * Math.cos(rotatedAngle));
                        y = center.y + (r * Math.sin(rotatedAngle));
                        let vertex = { x: x, y: y }
                        if (this.projection != null) {
                            vertex = featureDrawer.transformCoordinates(vertex);
                        }
                        allPoints.push([vertex.x, vertex.y]);
                    } else {
                        let difference = endAngle - startAngle;
                        if (difference < 0) {
                            difference += 2 * Math.PI;
                        }
                        let rotatedAngle, x, y;
                        startAngle = startAngle - (0.5 * Math.PI);
                        for (let i = 0; i < (difference * (180 / Math.PI)); ++i) {
                            rotatedAngle = startAngle + (i * (Math.PI / 180));
                            x = center.x + (r * Math.cos(rotatedAngle));
                            y = center.y + (r * Math.sin(rotatedAngle));
                            let vertex = { x: x, y: y }
                            if (this.projection != null) {
                                vertex = featureDrawer.transformCoordinates(vertex);
                            }
                            allPoints.push([vertex.x, vertex.y]);
                        }
                        rotatedAngle = endAngle - (0.5 * Math.PI);
                        x = center.x + (r * Math.cos(rotatedAngle));
                        y = center.y + (r * Math.sin(rotatedAngle));
                        let vertex = { x: x, y: y }
                        if (this.projection != null) {
                            vertex = featureDrawer.transformCoordinates(vertex);
                        }
                        allPoints.push([vertex.x, vertex.y]);
                    }
                } else {
                    let start = { x: lastSegment.X, y: lastSegment.Y };
                    let end = { x: segment.X, y: segment.Y };
                    if (this.projection != null) {
                        start = featureDrawer.transformCoordinates(start);
                        end = featureDrawer.transformCoordinates(end);
                    }
                    allPoints.push([start.x, start.y], [end.x, end.y]);
                }
            } else {
                let start = { x: segment.X, y: segment.Y };
                if (this.projection != null) {
                    start = featureDrawer.transformCoordinates(start);
                }
                allPoints.push([start.x, start.y]);
            }

            lastSegment = segment;
        });

        // Create a single LineString feature with all accumulated points 
        const combinedLineString = allPoints.length > 1 ? new LineString(allPoints) : new Point(allPoints[0]);
        const combinedFeature = new Feature(combinedLineString);

        combinedFeature.set("motionplan", this.motionplan);
        this.source.addFeature(combinedFeature);
    }

    deselectMotionplan() {
        this.selectInteraction.getFeatures().clear();
    }
}